import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Ortak } from './../../../providers/ortak';
import { Component } from '@angular/core';
import {   NavController, NavParams } from 'ionic-angular';
import { DateTime } from 'ionic-angular/components/datetime/datetime';
import { getLocaleDateTimeFormat } from '../../../../node_modules/@angular/common';



@Component({
  selector: 'page-sayim-girisi',
  templateUrl: 'sayim-girisi.html',
})
export class SayimGirisiPage {
  Stok:any={ID:1,StokAdi:"",Miktar:""};
  vwUrun:any={};
  tarih1=getLocaleDateTimeFormat.toString();
  tarih2:any;
   
  SayimHareketi:any={ID:-1,StokKartID:-1,IslemTarihi:DateTime,IslemTuru:4,DepoKodu:0,Miktar:"",SlsMan:1,Sign:1,}
  constructor(public navCtrl: NavController,public ortak:Ortak,public bllOrtak:BllOrtak,public viewCtrl:ViewController, public navParams: NavParams) {
    if(navParams.get("vwUrun")!=null){
      this.vwUrun=navParams.get("vwUrun");
      var data=new FormData();
      data.append("Stok_id",this.vwUrun.ID);
      this.bllOrtak.islem(data,"StokGetirByID","",false).then(a=>{
        var Sonuc=<any>a;
        this.Stok=Sonuc.SonucObject;
        this.SayimHareketi.StokKartID=this.Stok.ID;
       
      }
    )
  }
  }

  ionViewDidLoad() {

   
   
  
  }
kapat(){
  this.viewCtrl.dismiss();
}
saat(){

}
kaydet() {

  var formData = new FormData();

  formData.append("Sayim_json", JSON.stringify(this.SayimHareketi));



  this.bllOrtak.islem(formData, "StokSayim", "", false).then(a => {
    var sonuc = <any>a;
    if (sonuc.Sonuc == 1)
    {
      this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.viewCtrl.dismiss();
    }
   
    if(sonuc.Sonuc==99) console.log(sonuc.Exception);
    

  })


}
}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/sayim-girisi/sayim-girisi.ts